import { Link, useLocation } from 'react-router-dom';
import { Plus, Compass, Users, ChevronDown } from "lucide-react"
import CommunityForm from '../communities/CommunityForm';
import { useState } from 'react';
import Modal from '../common/Modal';

const tabs = [
  { name: "Discover", href: "/communities/discover", icon: Compass },
  { name: "My Communities", href: "/communities/my-communities", icon: Users },
]

export function CommunityNav() {
  const pathname = useLocation().pathname;
  const [showCreateModal, setShowCreateModal] = useState(false);

  // Handle community creation success
  const handleCommunityCreated = (newCommunity) => {
    setShowCreateModal(false);
    // Refresh communities list would happen automatically
  };

  return (
    <>
    <div className="mb-8">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <nav className="flex space-x-2" aria-label="Tabs">
          {tabs.map((tab) => {
            const isActive = pathname.startsWith(tab.href)
            return (
              <Link
                key={tab.name}
                to={tab.href}
                className={`
                  flex items-center gap-2 whitespace-nowrap py-2.5 px-4 rounded-lg font-medium text-sm transition-colors
                  ${
                    isActive
                      ? "bg-indigo-600 text-white shadow-sm"
                      : "text-gray-700 hover:text-gray-900 hover:bg-gray-100   "
                  }
                `}
              >
                <tab.icon className="w-4 h-4" />
                {tab.name}
              </Link>
            )
          })}
        </nav>

        <div className="flex items-center gap-3">
          <div className="relative">
            <button className="flex items-center gap-2 px-4 py-2.5 border border-gray-200  rounded-lg bg-white  hover:bg-gray-50  transition-colors text-sm shadow-sm">
              <span>Sort by</span>
              <ChevronDown className="w-4 h-4" />
            </button>
          </div>

          <Link
            // to="/community/create"
            to="#"
            onClick={(e) => {
                e.preventDefault();
                setShowCreateModal(true);
            }}
            className="inline-flex items-center gap-2 px-4 py-2.5 border border-transparent text-sm font-medium rounded-lg text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:opacity-90 transition-opacity shadow-sm"
          >
            <Plus className="w-4 h-4" />
            Create Community
          </Link>
        </div>
      </div>
    </div>

    <Modal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        title="Create a Community"
      >
        <CommunityForm
          onSuccess={handleCommunityCreated}
          onCancel={() => setShowCreateModal(false)}
        />
      </Modal>
    </>
  )
}

